import { Filter } from '@devexpress/dx-react-grid';
import dayjs from 'dayjs';

import { parseImperialLengthToInches } from '@paragon/client-tools';

export function distancesToString(heights: readonly number[], distanceFormatter: (distance: number) => string) {
  return heights.length === 0 ? '' : heights.length === 1 ? distanceFormatter(heights[0]) : 'Mixed';
}

export function trimmedCaseInsensitiveFilter(value: any, filter: Filter) {
  return value?.toString().toLowerCase().includes(filter.value.toLowerCase().trim()) ?? false;
}

export function lengthFilter(value: unknown, filter: Filter) {
  if (typeof value !== 'string') return false;
  const valueInInches = parseImperialLengthToInches(value);
  if (valueInInches === null) return false;
  const filterValueInInches = parseImperialLengthToInches(filter.value);
  if (filterValueInInches === null) return false;
  return valueInInches === filterValueInInches;
}

export function formatDateToString(date: string) {
  return dayjs(date).toDate().toLocaleDateString();
}

export function compareDates(a: string | null, b: string | null) {
  if (a === null && b === null) return 0;
  if (a === null) return 1;
  if (b === null) return -1;
  return Date.parse(a) - Date.parse(b);
}

export function compareDistanceStrings(a: string, b: string) {
  return parseImperialLengthToInches(a)! - parseImperialLengthToInches(b)!;
}
